/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IAppointments } from 'app/shared/model/appointments.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { Potentials } from 'app/shared/model/enumerations/potentials.model';

export interface IPatientMarker {
  id?: string;
  potentialFor?: keyof typeof Potentials | null;
  procedureType?: string | null;
  modeOfPayment?: string | null;
  remarks?: string | null;
  academicInterest?: boolean | null;
  complete?: boolean;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  active?: boolean;
  cursor?: number;
  appointment?: IAppointments;
  doctor?: IDoctor;
  patient?: IGlucoUser;
}

export const defaultValue: Readonly<IPatientMarker> = {
  academicInterest: false,
  complete: false,
  active: false,
};
